module.exports = __webpack_public_path__ + "static/media/img_howto_web_illust2_1@3x.99f6d621.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_howto_web_illust2_1@3x.png
// module id = 1080
// module chunks = 0